export const langEn = {
  html_title: 'AlcmeonChat',
  title: 'Your remote advisors',
  subtitle: 'We answer all your questions-',
  privacy_link_prefix: 'You can read our privacy policy',
  privacy_link_label: 'here',
  send_a_message: 'Send a message...',
  send_your_email: 'Enter your email address...',
  send_your_phone: 'Send your phone number, in +33612345678 format',
  select_an_option: 'Select an option',
  close_menu: 'Close menu',
  'aria_label/close': 'close',
  'aria_label/close-menu': 'close',
  'aria_label/file-upload': 'upload image or PDF document',
  'aria_label/open_alcmeon_inmessage': 'open the chat',
  'aria_label/options': 'options',
  'aria_label/send_message': 'send the message',
  'alt/an_image': 'an image',
  helperMessage1: `Hello 🙂<br/>Do you have a question ?`,
  helperMessage2: `Ask me anything👇👇`,
  helperMessage3: `<strong>You have an ongoing conversation</strong>`,
  helperMessage4: `Continue here 👉`,
  waitingMessage: `An advisor will answer you soon. You are currently in position {{position}}. Your estimated waiting time is {{time}}, please wait.`,
  lessThan:'less than',
  moreThan:'more than',
  minutes:'min'
};
